import { render, staticRenderFns } from "./BotPoiCard.vue?vue&type=template&id=5dfeacd6&"
import script from "./BotPoiCard.vue?vue&type=script&lang=ts&"
export * from "./BotPoiCard.vue?vue&type=script&lang=ts&"
import style0 from "./BotPoiCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports